<template>
    <div class="fs-address-bar mb-2">

        <!-- TITLE -->
        <span class="mr-2">Address</span>

        <!-- ADDRESS -->
        <input
            class="fs-inset-pane w-100 px-2"
            type="text"
            :value="cleanURL"
        >

        <!-- <input class="fs-inset-pane w-100 px-2" type="text" name="Path" :value="'unfiltered: '+pathString"> -->
        <!-- <select class="custom-select"> -->
            <!-- <option>{{ directoryPath }}</option> -->
            <!-- <option v-for="item in directoryContents" :value="item.name">{{ item.name }}</option> -->
        <!-- </select> -->

        <!-- SEARCH: | address doubles as a search -->
        <!-- <input name="query" class="w-100 mb-3" v-model="searchQuery"> -->

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            path: {
                type: String,
                required: false
            },
            searchQuery: {
                type: String,
                required: false
            }
        },
        computed: {
            cleanURL() {
                const pathSteps = this.path.split('/');

                // console.log(pathSteps);

                if (pathSteps.length == 2) {
                    return pathSteps[1].substr(0); // eg. Desktop
                }

                if (pathSteps.length == 3) {
                    return pathSteps[2].substr(0);
                }

                if (pathSteps.length >= 3 && pathSteps[2] === 'My Computer') {
                    return pathSteps.splice(3, pathSteps.length).join('/');
                }

                return this.path;
            }
        },
        created() {

        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // PATH BAR
    //-----------------------------------------------------------------

    .fs-address-bar {
        display: flex;
        align-items: center;
    }

    .fs-address-bar {
        .custom-select {
            border-radius: 0;
            padding: rem-calc(5 10);
            background-color: #f6f6f2; // TODO variable all of these
            border-top: 2px solid #b9b9b6;
            border-left: 2px solid #b9b9b6;
        }
    }
</style>